import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";

import { FC } from "react";
import { useParams } from "react-router";

export const CollectionsViewPage: FC = () => {
  const { collectionId } = useParams<{ collectionId: Uuid }>();

  if (!collectionId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["collection-by-id", collectionId],
    queryFn: () =>
      api.get("/internal/v1/collections/{collection_id}", {
        params: {
          path: {
            collection_id: collectionId,
          },
        },
      }),
  });

  return (
    <div>
      <h1>View Collection</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
